class CartMotivator extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.workingProgress = false
        this.exclusionIds = JSON.parse(this.getAttribute("data-excluded-ids") ?? null)
        console.log("this.exclusionIds", this.exclusionIds)
        this.excludedCollectionsIds = JSON.parse(
            this.getAttribute("data-excluded-collections") ?? null,
        )
        console.log("this.excludedCollectionsIds", this.excludedCollectionsIds)
        this.tiersData = JSON.parse(this.getAttribute("data-tiers") ?? null)
        console.log("this.tiersData", this.tiersData)
        this.bars = this.querySelectorAll(".progress-gift-purchase-bar")
        this.querySelectorAll(".free-gift-purchase-card-checkbox").forEach(checkboxEl => {
            checkboxEl.addEventListener("click", this.applyVariantView)
        })
        this.querySelectorAll(".free-gift-purchase-product-info-container").forEach(inforEl => {
            inforEl.addEventListener("click", this.applyVariantView)
        })
        this.querySelectorAll(".variant-container-arrow-left").forEach(arrowEl => {
            arrowEl.addEventListener("click", e => {
                this.handleContainerSlide(e, true)
            })
        })
        document.querySelectorAll(".variant-container-arrow-right").forEach(arrowEl => {
            arrowEl.addEventListener("click", e => {
                this.handleContainerSlide(e, false)
            })
        })
        this.headers = JSON.parse(this.dataset.giftHeaders ?? "{}")
        this.labels = JSON.parse(this.dataset.giftRemaining ?? "{}")
        this.querySelectorAll(".option-variant-input").forEach(variantEl => {
            variantEl.addEventListener("change", this.optionVariantChange)
        })
        const sliderContainer = this.querySelector(".free-gift-purchase-container-slider")
        const cardsContainer = sliderContainer.querySelector(".free-gift-purchase-slider")
        const cardsWidth = [...cardsContainer.querySelectorAll(".free-gift-purchase-card")]
            .map(card => {
                return Number(this.getWidth_wm(card))
            })
            .reduce((a, b) => a + b, 0)
        if (cardsWidth < Number(this.getWidth_wm(cardsContainer))) {
            sliderContainer.querySelectorAll("i").forEach(i => (i.style.opacity = "0"))
        }
        this.initCartObserver()
    }

    get_cart_total = cart =>
        cart.items
            .filter(
                item =>
                    !(
                        this.exclusionIds.includes(item.product_id) ||
                        this.excludedCollectionsIds.some(excludedCollectionId =>
                            item.collection_ids.includes(excludedCollectionId),
                        )
                    ) && !item.properties._giftProduct,
            )
            .reduce((a, b) => a + b.line_price, 0)

    checkCart = async () => {
        const cart = await this.getCart()
        this.updateGwpConfigAttribute(cart)
        const currentLastAllowedTier = Number(localStorage.getItem("lastAllowedTier")) || 1
        const cartValue = this.get_cart_total(cart)
        const giftInCart = this.getGiftInCart({ cart })
        this.updateProgressBar({ cartValue })
        this.updateContainerLabels({ tiers: this.tiersData, cartValue })
        const { giftToRemove, giftToUpdate, newProductGifts } = this.checkGifts({
            productGifts: giftInCart,
            tiers: this.tiersData,
            cartValue,
        })
        const giftState = JSON.parse(localStorage.getItem("giftState") ?? "null") || {
            state: "auto-added",
        }
        let autoAdd = true
        if (
            giftState.state === "auto-added" ||
            currentLastAllowedTier !== (Number(localStorage.getItem("lastAllowedTier")) || 1)
        ) {
            const { giftToRemove: secondaryGiftsToRemove, isAutoAdded } = await this.autoAdd({
                productGifts: newProductGifts,
                tiers: this.tiersData,
                cartValue,
            })
            autoAdd = isAutoAdded
            giftToRemove.push(...secondaryGiftsToRemove)
        }
        const removeResponse = await this.removeProductFromCart({ items: giftToRemove })
        const updateResponse = await this.updateQuantityFromCart({ items: giftToUpdate })
        this.checkGiftCards({ productGifts: newProductGifts, cartValue })
        if (removeResponse || updateResponse || autoAdd) {
            this.updateCartDrawer()
        }
    }

    updateContainerLabels = ({ tiers, cartValue }) => {
        const headerContainer = this.querySelector(".info-gift-purchase-title p")
        const remainingContainer = this.querySelector(".info-gift-purchase-text")
        const currentTier = tiers
            .sort((a, b) => a.tier_value - b.tier_value)
            .find(tier => cartValue <= tier.tier_value)

        if (currentTier) {
            const remaining = this.convertToMoney({
                amount: currentTier.tier_value - cartValue,
                removeTrailingZeros: true,
            })
            const remainngFinalContainer = `<b>${remaining}</b>`
            remainingContainer.innerHTML = `<p>${currentTier.remaining_label.replace(
                "[VALUE]",
                remainngFinalContainer,
            )}</p>`
            headerContainer.innerHTML = currentTier.header_label
            remainingContainer.style.display = "grid"
        } else {
            remainingContainer.style.display = "none"
            headerContainer.innerHTML = this.getAttribute("data-primary-label")
        }
    }

    autoAdd = async ({ productGifts, tiers, cartValue }) => {
        const giftToRemove = []
        const giftToAdd = []
        let isInCart = false
        let isAutoAdded = false
        tiers
            .sort((a, b) => b.tier_value - a.tier_value)
            .forEach(tier => {
                const defaultVariantId = tier.variants_ids.at(0)
                const giftsFromTier = productGifts.filter(productGift =>
                    tier.variants_ids.includes(productGift.variant_id),
                )
                if (
                    tier.allowed &&
                    tier.tier_value <= cartValue &&
                    giftToAdd.length === 0 &&
                    !isInCart
                ) {
                    if (
                        !giftsFromTier.some(
                            productGift => productGift.variant_id === defaultVariantId,
                        )
                    ) {
                        giftToAdd.push({ id: defaultVariantId })
                    } else {
                        isInCart = true
                    }
                } else {
                    giftToRemove.push(...giftsFromTier.splice(0))
                }
            })

        if (giftToAdd.length) {
            const responseAdd = await this.addProductToCart(giftToAdd.at(0))
            if (responseAdd.state) {
                isAutoAdded = true
                localStorage.setItem("giftState", JSON.stringify({ state: "auto-added" }))
            }
        }

        return {
            giftToRemove,
            isAutoAdded,
        }
    }

    checkGifts = ({ productGifts, tiers, cartValue }) => {
        if (!productGifts?.length) {
            return { giftToRemove: [], giftToUpdate: [], newProductGifts: productGifts }
        }
        const giftToRemove = []
        const giftToUpdate = []
        const newProductGifts = []
        const sortedTiers = tiers.sort((a, b) => b.tier_value - a.tier_value)

        const allowedVariantIds = tiers.flatMap(tier => tier.variants_ids)

        productGifts.forEach(productGift => {
            if (!allowedVariantIds.includes(productGift.variant_id)) {
                giftToRemove.push(productGift)
            }
        })

        localStorage.setItem(
            "lastAllowedTier",
            sortedTiers.find(tier => tier.allowed && tier.tier_value <= cartValue)?.tier_id || 1,
        )
        sortedTiers.forEach(tier => {
            const giftsFromTier = productGifts.filter(productGift =>
                tier.variants_ids.includes(productGift.variant_id),
            )
            if (!giftsFromTier.length) {
                return
            }
            if (tier.allowed && tier.tier_value <= cartValue && newProductGifts.length === 0) {
                if (giftsFromTier.length > 1) {
                    giftToRemove.push(...giftsFromTier.splice(1))
                }
                newProductGifts.push(...giftsFromTier)
            } else {
                giftToRemove.push(...giftsFromTier.splice(0))
            }
            if (giftsFromTier.length) {
                giftToUpdate.push(...giftsFromTier.filter(gift => gift.quantity > 1))
            }
        })
        return {
            giftToRemove,
            giftToUpdate,
            newProductGifts,
        }
    }

    checkGiftCards = ({ productGifts, cartValue }) => {
        this.querySelectorAll(".free-gift-purchase-card").forEach(giftCard => {
            const giftCardMinimumAmount = Number(giftCard.getAttribute("data-minimum-amount")) || 0
            const giftCardId = Number(giftCard.getAttribute("data-id")) || 0
            const allowedGiftCard = cartValue >= giftCardMinimumAmount
            const giftCardInCart = productGifts.some(
                productGift => productGift.product_id === giftCardId,
            )
            if (allowedGiftCard) {
                this.setGiftCardState({ giftCard, state: "unlocked" })
            } else {
                this.setGiftCardState({ giftCard, state: "locked" })
            }

            if (giftCardInCart) {
                this.setGiftCardState({ giftCard, state: "oncart" })
            }
        })
    }

    updateProgressBar = ({ cartValue }) => {
        this.bars.forEach((barContainer, index) => {
            const minimunAmount = Number(barContainer?.getAttribute("data-minimun-amount")) || 0
            const progressIconLabel = this.querySelector(
                `.progress-gift-purchase-icon-${index + 1}`,
            )
            const progressTextLabel = this.querySelector(
                `.progress-gift-purchase-text-${index + 1}`,
            )
            if (cartValue >= minimunAmount) {
                barContainer.style.width = "100%"
                progressIconLabel.src = progressIconLabel.dataset.completeSrc ?? ""
                progressTextLabel.classList.remove("locked")
                progressTextLabel.classList.add("unlocked")
                progressIconLabel.parentNode.classList.add(
                    "progress-gift-purchase-icon-container-unloked",
                )
            } else {
                progressIconLabel.src = progressIconLabel.dataset.uncompleteSrc
                progressIconLabel.parentNode.classList.remove(
                    "progress-gift-purchase-icon-container-unloked",
                )
                progressTextLabel.classList.remove("unlocked")
                progressTextLabel.classList.add("locked")
                const minimunPreviousAmount =
                    Number(
                        this.querySelector(`.progress-gift-purchase-bar-${index}`)?.getAttribute(
                            "data-minimun-amount",
                        ),
                    ) || 0
                const auxiliarCartPrice = cartValue - minimunPreviousAmount
                const auxiliarMinimunAmount = minimunAmount - minimunPreviousAmount
                if (auxiliarCartPrice > 0) {
                    barContainer.style.width = `${
                        Number(auxiliarCartPrice / auxiliarMinimunAmount) * 100
                    }%`
                } else {
                    barContainer.style.width = "0%"
                }
            }
        })
    }

    getGiftInCart = ({ cart }) => cart.items.filter(lineItem => lineItem.properties._giftProduct)

    // State: locked | unlocked | selected | oncart
    setGiftCardState = ({ giftCard, state }) => {
        const checkBoxLabel = giftCard.querySelector(".free-gift-purchase-card-checkbox")
        const checkBox = checkBoxLabel.querySelector("input.cart-motivator-item-radio")
        switch (state) {
            case "locked":
                giftCard.classList.add("preview")
                giftCard.classList.remove("selected")
                checkBoxLabel.classList.add("locked")
                checkBoxLabel.classList.remove("unlocked")
                giftCard.querySelector(".free-gift-purchase-product-info-container").style.display =
                    "grid"
                giftCard.querySelector(
                    ".free-gift-purchase-product-variant-container",
                ).style.display = "none"
                checkBox.checked = false
                checkBox.classList.remove("cart-motivator-item-radio-item-selected")
                giftCard.querySelectorAll("input[type='radio']").forEach(input => {
                    input.checked = false
                })
                break
            case "unlocked":
                giftCard.classList.remove("preview")
                giftCard.classList.remove("selected")
                checkBoxLabel.classList.remove("locked")
                checkBoxLabel.classList.add("unlocked")
                checkBox.checked = false
                checkBox.classList.remove("cart-motivator-item-radio-item-selected")
                giftCard.querySelectorAll("input[type='radio']").forEach(input => {
                    input.checked = false
                })
                break
            case "selected":
                giftCard.classList.add("selected")
                checkBoxLabel.classList.remove("locked")
                checkBoxLabel.classList.add("unlocked")
                giftCard.querySelector(".free-gift-purchase-product-info-container").style.display =
                    "none"
                giftCard.querySelector(
                    ".free-gift-purchase-product-variant-container",
                ).style.display = "none"
                checkBox.checked = true
                checkBox.classList.remove("cart-motivator-item-radio-item-selected")
                giftCard.querySelectorAll("input[type='radio']").forEach(input => {
                    input.checked = false
                })
                break
            case "oncart":
                checkBoxLabel.classList.remove("locked")
                checkBoxLabel.classList.add("unlocked")
                giftCard.querySelector(".free-gift-purchase-product-info-container").style.display =
                    "grid"
                giftCard.querySelector(
                    ".free-gift-purchase-product-variant-container",
                ).style.display = "none"
                checkBoxLabel.classList.add("unlocked")
                checkBox.checked = true
                checkBox.classList.remove("cart-motivator-item-radio-item-selected")
                break
        }
    }

    applyVariantView = async e => {
        const el = e.currentTarget
        var productContainer = null
        if (el.classList.contains("free-gift-purchase-card-checkbox")) {
            productContainer = el.parentNode
        } else if (el.classList.contains("free-gift-purchase-product-info-container")) {
            productContainer = el.parentNode.parentNode.parentNode
        }
        this.querySelector(".free-gift-purchase-card")?.classList.remove("selected")
        this.querySelector(".cart-motivator-item-radio").checked = false
        this.querySelector(".free-gift-purchase-product-info-container").style.display = "block"
        this.querySelector(".free-gift-purchase-product-variant-container").style.display = "none"
        productContainer.classList.add("selected")
        productContainer.querySelector(".cart-motivator-item-radio").checked = true
        const itemId =
            productContainer.querySelector(".free-gift-purchase-product-info-container-default")
                ?.dataset.id ?? false
        if (itemId) {
            const selectedVariant = JSON.parse(
                this.querySelector(`.bundle-variant-data-input-${itemId}`)?.getAttribute(
                    "data-variant",
                ) ?? "null",
            )
            const cart = await this.getCart()
            const giftsInCart = this.getGiftInCart({ cart })
            let removeResponse = { state: true }
            if (
                giftsInCart.length &&
                giftsInCart.some(giftInCart => selectedVariant.id !== giftInCart.variant_id)
            ) {
                removeResponse = await this.removeProductFromCart({ items: giftsInCart })
            }
            const addResponse = await this.addProductToCart(selectedVariant)

            if (removeResponse.state && addResponse.state) {
                this.updateCartDrawer()
            }
            localStorage.setItem("giftState", JSON.stringify({ state: "manual-added" }))
        } else {
            productContainer.querySelector(
                ".free-gift-purchase-product-info-container",
            ).style.display = "none"
            productContainer.querySelector(
                ".free-gift-purchase-product-variant-container",
            ).style.display = "grid"
            productContainer.querySelector(".option-variant-input").checked = false
            el.parentNode.querySelector(
                ".free-gift-purchase-product-variant-container",
            ).style.display = "grid"
            const variantContainers = el.parentNode.querySelectorAll(
                ".free-gift-purchase-product-variant-container .free-gift-purchase-product-container",
            )
            variantContainers.forEach(variantContainer => {
                const fatherWidth = Number(this.getWidth(variantContainer)) - 30
                const childWidth = Number(
                    [
                        ...variantContainer.querySelectorAll(
                            ".variant-container-scroll .variant-container-scroll-option",
                        ),
                    ]
                        .map(child => {
                            return Number(this.getWidth(child))
                        })
                        .reduce((a, b) => a + b, 0),
                )
                if (fatherWidth > childWidth) {
                    variantContainer.querySelector(".variant-container-arrow").style.opacity = "0"
                }
            })
        }
    }

    optionVariantChange = async e => {
        const el = e.currentTarget
        const itemId = el.dataset.id
        const itemPosition = Number(el.dataset.optionPosition)
        const optionCount = this.querySelectorAll(
            ".free-gift-purchase-product-container-" + itemId,
        ).length
        const jsonVariants = [...this.querySelectorAll(`.bundle-variant-data-input-${itemId}`)].map(
            item => {
                return JSON.parse(item.dataset.variant)
            },
        )
        const jsonData = [null, null, null]
        const optionSelectedValue = {}
        for (let i = 1; i <= optionCount; i++) {
            const optionSelected = this.querySelector(
                `.option-variant-input-${itemId}-${i}:checked`,
            )
            if (optionSelected) {
                jsonData[i - 1] = optionSelected.value
            }
            if (optionSelected === el) {
                optionSelectedValue.index = i
                optionSelectedValue.value = el.value
            }
        }
        const filteredOptions = jsonVariants.filter(variant => {
            let isVariant =
                variant[`option${optionSelectedValue.index}`] === optionSelectedValue.value
            return isVariant && variant.available ? variant : false
        })
        const options = []
        filteredOptions.map(variant => {
            for (let i = 1; i <= 3; i++) {
                if (options.some(option => option.index === i)) {
                    options.map(option => {
                        if (option.index === i && !option.values.includes(variant[`option${i}`])) {
                            option.values.push(variant[`option${i}`])
                        }
                    })
                } else {
                    options.push({
                        index: i,
                        values: [variant[`option${i}`]],
                    })
                }
            }
        })
        options.map(option => {
            this.querySelectorAll(
                `.option-variant-input-${itemId}[data-option-position='${option.index}']`,
            ).forEach(optionContainer => {
                if (itemPosition === option.index) {
                    optionContainer.disabled = false
                } else {
                    optionContainer.disabled = !option.values.includes(optionContainer.value)
                }
            })
        })
        const finalJsonData = jsonData.filter(data => data !== null)
        if (finalJsonData.length === optionCount) {
            const selectedVariant = jsonVariants.find(variant => {
                var isSelectedVariant = true
                finalJsonData.map((value, index) => {
                    if (variant["option" + (index + 1)] != value) {
                        isSelectedVariant = false
                    }
                })
                if (isSelectedVariant) {
                    return variant
                }
            })
            const cart = await this.getCart()
            const giftsInCart = this.getGiftInCart({ cart })
            let removeResponse = { state: true }
            if (
                giftsInCart.length &&
                giftsInCart.some(giftInCart => selectedVariant.id !== giftInCart.variant_id)
            ) {
                removeResponse = await this.removeProductFromCart({ items: giftsInCart })
            }
            const addResponse = await this.addProductToCart(selectedVariant)

            if (removeResponse.state && addResponse.state) {
                this.updateCartDrawer()
            }
            localStorage.setItem("giftState", JSON.stringify({ state: "manual-added" }))
        }
    }

    handleContainerSlide = (e, direction) => {
        const el = e.currentTarget
        const container = el.parentNode.querySelector(".variant-container-scroll")
        const leftPos = container.scrollLeft
        container.scrollTo({
            left: leftPos + (direction ? -1 : 1) * 40,
            behavior: "smooth",
        })
    }

    getWidth = theDiv => {
        theDiv = $(theDiv)
        var totalWidth = theDiv.width()
        totalWidth +=
            parseInt(theDiv.css("padding-left"), 10) + parseInt(theDiv.css("padding-right"), 10) //Total Padding Width
        totalWidth +=
            parseInt(theDiv.css("margin-left"), 10) + parseInt(theDiv.css("margin-right"), 10) //Total Margin Width
        totalWidth +=
            parseInt(theDiv.css("borderLeftWidth"), 10) +
            parseInt(theDiv.css("borderRightWidth"), 10) //Total Border Width
        return totalWidth
    }

    getWidth_wm = theDiv => {
        theDiv = $(theDiv)
        var totalWidth = theDiv.width()
        totalWidth +=
            parseInt(theDiv.css("padding-left"), 10) + parseInt(theDiv.css("padding-right"), 10) //Total Padding Width
        totalWidth +=
            parseInt(theDiv.css("borderLeftWidth"), 10) +
            parseInt(theDiv.css("borderRightWidth"), 10) //Total Border Width
        return totalWidth
    }

    convertToMoney = ({ amount, removeTrailingZeros = false }) => {
        const finalAmount = (typeof amount === "string" ? Number(amount) : amount) / 100

        const currency = window?.Shopify?.currency?.active || "USD"

        const localeString = `${window?.Shopify?.locale || "en"}-${
            window?.Shopify?.country || "US"
        }`

        const fixedAmount = Number(finalAmount.toFixed(2))

        let formattedAmount = fixedAmount.toLocaleString(localeString, {
            style: "currency",
            currency: currency,
            minimumFractionDigits: removeTrailingZeros ? 0 : 2,
            maximumFractionDigits: removeTrailingZeros ? 2 : 2,
        })

        if (removeTrailingZeros) {
            const decimalSeparator = (1.1).toLocaleString(localeString).charAt(1)
            const amount = formattedAmount.match(/-?\d+(\.\d+)?/)?.[0] || "0"
            if (amount.length === 0) {
                formattedAmount += `${decimalSeparator}00`
            } else {
                formattedAmount = formattedAmount
                    .replace(new RegExp(`\\${decimalSeparator}0+$`), "")
                    .replace(new RegExp(`\\${decimalSeparator}$`), "")
            }
        }

        return formattedAmount
    }

    addProductToCart = async variant => {
        if (!variant.id) return { state: false }
        const formData = { items: [] }
        const rawItem = {
            id: variant.id,
            quantity: 1,
            properties: {
                _giftProduct: true,
            },
        }
        formData.items.push(rawItem)
        try {
            const addResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            }).then(res => res.json())
            if (addResponse) {
                return { state: true }
            } else {
                return { state: false }
            }
        } catch (err) {
            return { state: false }
        }
    }

    updateGwpConfigAttribute = async cart => {
        const currentData = cart.attributes["_giftConfig"]
            ? JSON.parse(this.decodeHtml(cart.attributes["_giftConfig"]) ?? "null")
            : {}
        const newData = {
            exclusion_ids: this.exclusionIds,
            excluded_collection_ids: this.excludedCollectionsIds,
            tiers_data: this.tiersData,
        }
        if (!this.checkObjectValues(currentData, newData)) {
            await this.updateCartAttributes({ key: "_giftConfig", value: newData })
        }
    }

    updateCartAttributes = async ({ key, value }) => {
        const formData = new FormData()
        const parsedValue = typeof value === "object" ? JSON.stringify(value) : value
        formData.append(`attributes[${key}]`, parsedValue)
        try {
            const fetchResponse = await fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                body: formData,
            }).then(res => res.json())
            return { state: fetchResponse.attributes[key] ? true : false }
        } catch (err) {
            return { state: false }
        }
    }

    removeProductFromCart = async ({ items }) => {
        if (!items?.length) {
            return { state: true }
        }
        const formData = { updates: {} }
        items.forEach(item => {
            formData["updates"][item.key] = 0
        })
        try {
            const updateResponse = await fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            }).then(res => res.json())
            return { state: updateResponse.items !== null }
        } catch (er) {
            return { state: false }
        }
    }

    updateQuantityFromCart = async ({ items }) => {
        if (!items?.length) {
            return { state: true }
        }
        const formData = { updates: {} }
        items.forEach(item => {
            formData["updates"][item.key] = 1
        })
        const updateFetch = await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }).catch(error => {
            return { state: false }
        })
        const updateResponse = await updateFetch.json()
        if (updateResponse) {
            return { state: true }
        } else {
            return { state: false }
        }
    }

    checkGiftInCart = async () => {
        let conditionMet = false
        while (!conditionMet) {
            try {
                const cart = await fetch("/cart.js").then(response => response.json())
                if (
                    cart.items.some(
                        lineItem =>
                            lineItem.discounts.some(discount => discount.title === "freegift") &&
                            lineItem.properties._giftProduct,
                    )
                ) {
                    conditionMet = true
                } else {
                    await new Promise(resolve => setTimeout(resolve, 1000)) // 1 second delay
                }
            } catch (error) {
                console.error("Error fetching data:", error)
                break
            }
        }
    }

    getCart = async () => {
        try {
            const rawResponse = await fetch("/").then(res => res.text())
            if (!rawResponse) {
                return null
            }
            const parser = new DOMParser()
            const docu = parser.parseFromString(rawResponse, "text/html")
            return JSON.parse(docu.querySelector("#cart-json-custom").value)
        } catch (e) {
            console.error(e)
            return null
        }
    }

    updateCartDrawer = () => {
        document.dispatchEvent(new CustomEvent("cart:build"))
    }

    initCartObserver = () => {
        const cartObserver = new PerformanceObserver(list => {
            list.getEntries().forEach(rawEntry => {
                const entry = rawEntry.toJSON()
                const isValidRequestType = ["xmlhttprequest", "fetch"].includes(entry.initiatorType)
                const regex = /\/cart(\/(?!\.js\b)[^ ]*|$)/
                const isCartChangeRequest = regex.test(entry.name)
                if (isValidRequestType && isCartChangeRequest) {
                    this.checkCart()
                }
            })
        })

        cartObserver.observe({ entryTypes: ["resource"] })
        this.checkCart()
    }

    decodeHtml = html => {
        const el = document.createElement("textarea")
        el.innerHTML = html
        return el.value
    }

    checkObjectValues = (obj1, obj2) => {
        if (obj1 === obj2) return true
        if (
            obj1 === null ||
            obj2 === null ||
            typeof obj1 !== "object" ||
            typeof obj2 !== "object"
        ) {
            return false
        }
        const keys1 = Object.keys(obj1)
        const keys2 = Object.keys(obj2)
        if (keys1.length !== keys2.length) return false
        for (let key of keys1) {
            if (!keys2.includes(key) || !this.check_object_values(obj1[key], obj2[key])) {
                return false
            }
        }

        return true
    }
}

class CartMotivatorDisabled extends HTMLElement {
    constructor() {
        super()
        this.checkCartAttributes()
    }
    updateCartAttributes = async () => {
        const formData = new FormData()
        formData.append("attributes[giftSetUp]", "")
        try {
            const fetchResponse = await fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                body: formData,
            }).then(res => res.json())
            if (fetchResponse.attributes["giftSetUp"] === "") {
                return { state: true }
            } else {
                return { state: false }
            }
        } catch (err) {
            return { state: false }
        }
    }
    checkCartAttributes = async () => {
        const cart = await fetch("/cart.js").then(res => res.json())
        if (cart.attributes["giftSetUp"] !== null) {
            await this.updateCartAttributes()
        }
    }
}

if (!customElements.get("cart-motivator")) {
    customElements.define("cart-motivator", CartMotivator)
}

if (!customElements.get("cart-motivator-disabled")) {
    customElements.define("cart-motivator-disabled", CartMotivatorDisabled)
}
